import React, { memo, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody, Spinner } from "reactstrap";
import {
  handleLogoutAgent,
  handleLogoutAgentConfirm,
} from "../../../../../../../../../../../../store/manager/actions";

import { showToast } from "../../../../../../../../../../../../Libs/CustomMethods/showToast";

import "./style.scss";
import { useTranslation } from "react-i18next";

function ButtonLogout({ id, isCard = false }) {
  const status = useSelector((state) => state.Manager.logoutAgentsStatus?.[id]);
  const hasPermission = useSelector(
    (state) => state.Login?.data?.permissions?.logout_other_user
  )?.includes("patch");
  const userId = useSelector((state) => state.Login?.data?.user?.id);

  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    dispatch(handleLogoutAgentConfirm(id));
  }, [dispatch, id]);

  if (!hasPermission) return null;

  return (
    <>
      <button
        className="button-logout"
        card={isCard ? "true" : "false"}
        onClick={handleClick}
        disabled={id === userId}
      >
        {status?.loading ? (
          <i className="fa fa-spinner fa-spin" />
        ) : (
          <i className="bx bx-power-off" />
        )}
      </button>
    </>
  );
}

export default memo(ButtonLogout);

export const ModalConfirmLogout = ({ id, isOpen = false }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const status = useSelector((state) => state.Manager.logoutAgentsStatus?.[id]);
  const dataAgents = useSelector((state) => state.Manager?.dataAgent?.agents);
  const generalStatus = useSelector(
    (state) => state.Manager.logoutAgentsStatus?.status
  );

  const agent = dataAgents?.find((item) => item.id === id);

  const handleCloseModal = useCallback(() => {
    if (status?.loading) return;
    if (status?.error) {
      status.error = false;
    }

    dispatch(handleLogoutAgentConfirm(null));
  }, [dispatch, status]);

  const handleConfirm = useCallback(() => {
    dispatch(handleLogoutAgent(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (generalStatus?.success) {
      showToast(t("Agent disconnected successfully!"), "success");
      generalStatus.success = false;
    }
  }, [generalStatus, t]);

  return (
    <Modal
      isOpen={isOpen || status?.loading}
      className="modal-logout"
      toggle={handleCloseModal}
    >
      <ModalBody>
        {status?.error ? (
          <>
            <h4>{t("This agent has conversations assigned")}</h4>
            <p>{t("Transfer engagements before disconnecting the agent")}</p>
          </>
        ) : (
          <>
            <h4>{t("Disconnect Agent")}</h4>
            <p>
              {`${t("Are you sure you want to disconnect")} [${
                agent?.name?.trim() ?? "-"
              }]?`}
            </p>
          </>
        )}
      </ModalBody>
      <div className="actions">
        {status?.error ? (
          <>
            <button className="btn btn-primary" onClick={handleCloseModal}>
              {t("Cancel")}
            </button>
          </>
        ) : (
          <>
            <button
              className="btn btn-outline-primary"
              onClick={handleCloseModal}
            >
              {t("Cancel")}
            </button>
            <button
              className="btn btn-primary"
              onClick={handleConfirm}
              disabled={status?.loading}
            >
              {status?.loading ? <Spinner size="sm" /> : t("Confirm")}
            </button>
          </>
        )}
      </div>
    </Modal>
  );
};
